<template>
  <v-select
    taggable
    ref="select"
    class="item-select-search"
    label="name"
    v-model="selection"
    :createOption="createOption"
    :filterable="false"
    :options="selectOptions"
    @search="onSearch"
    @change="change">
    <template slot="no-options">
      type to search {{ type }}..
    </template>
    <template slot="option" slot-scope="option">
      <div class="d-center">
        <img v-if="option.thumbnail" :src='option.thumbnail'/>
        <img v-if="!option.thumbnail && option.origin === 'search'" src="../assets/img/notfound.png" alt="">
        <img v-if="!option.thumbnail && option.origin !== 'search'" src="../assets/img/add.png" alt="">
        <div class="option-content" v-if="option.origin === 'search'">
          <strong>{{ option.name }}</strong> <span class="year" v-if="option.year">{{ option.year }}</span> <br>
          <span class="overview">{{ option.overview }}</span>
        </div>
        <div v-else class="option-content">
          <strong>{{ option.name }}</strong>
          <br>
          <small>Add this item!</small>
        </div>
      </div>
    </template>
  </v-select>
</template>

<script>
import _ from 'lodash'

import store from '@/store/index'

const TMDB_API_KEY = '3243c1338236f3bb769e486a9baea2b8'
const TMDB_URL = 'https://api.themoviedb.org/3/search/'
const TMDB_THUMBNAIL_URL = 'https://image.tmdb.org/t/p/w154'
const GOOGLE_BOOKS_URL = 'https://www.googleapis.com/books/v1/volumes'
const BOARDGAMEATLAS_URL = 'https://api.boardgameatlas.com/api/search'
const BOARDGAMEATLAS_KEY = '0Mfpues6JA'
const IGDB_URL = '/api/search_igdb/'

function parseYear (d) {
  if (d) {
    return new Date(d).getFullYear()
  }
  return null
}

function truncateText (s) {
  if (!s) return
  if (s.length > 990) {
    s = s.slice(0, 990) + '...'
  }
  return s
}

const content_types = {
  book: {
    getUrl (search) {
      return `${GOOGLE_BOOKS_URL}?q=${escape(search)}`
    },
    getResults (data) {
      return data.items
    },
    formatResult (i) {
      let description = i.volumeInfo.description || ''
      let overview = `By ${i.volumeInfo.authors.join(', ')}. ${description}`
      let thumbnail = null
      if (i.volumeInfo.imageLinks) {
        thumbnail = i.volumeInfo.imageLinks.thumbnail.replace('&edge=curl', '').replace('http://', 'https://')
      }
      return {
        name: i.volumeInfo.title,
        year: parseYear(i.volumeInfo.publishedDate),
        thumbnail: thumbnail,
        overview: truncateText(overview),
        source: 'googlebooks',
        source_id: i.id,
      }
    }
  },
  movie: {
    getUrl (search) {
      return `${TMDB_URL}movie?query=${escape(search)}&api_key=${TMDB_API_KEY}`
    },
    getResults (data) {
      return data.results
    },
    formatResult (i) {
      i.name = i.title;
      i.year = parseYear(i.release_date)
      i.thumbnail = `${TMDB_THUMBNAIL_URL}${i.poster_path}`
      i.source = 'tmdb'
      i.source_id = i.id
      return i
    }
  },
  tvshow: {
    getUrl (search) {
      return `${TMDB_URL}tv?query=${escape(search)}&api_key=${TMDB_API_KEY}`
    },
    getResults (data) {
      return data.results
    },
    formatResult (i) {
      i.name = i.original_name
      i.year = parseYear(i.first_air_date)
      i.thumbnail = `${TMDB_THUMBNAIL_URL}${i.poster_path}`
      i.source = 'tmdb'
      i.source_id = i.id
      return i
    }
  },
  game: {
    getUrl (search) {
      return `${window.location.origin}${IGDB_URL}?name=${search}&auth_token=${store.getters['users/token']}`
    },
    getResults (data) {
      return data
    },
    formatResult (i) {
      i.thumbnail = i.image_url
      i.year = parseYear(i.release_date)
      i.overview = i.summary
      i.source = 'igdb'
      i.source_id = i.id
      return i
    }
  },
  boardgame: {
    getUrl (search) {
      return `${BOARDGAMEATLAS_URL}?name=${escape(search)}&client_id=${BOARDGAMEATLAS_KEY}`
    },
    getResults (data) {
      return data.games
    },
    formatResult (i) {
      i.overview = truncateText(i.description_preview)
      i.year = i.year_published
      i.thumbnail = i.thumb_url
      i.link = i.url
      i.source = 'bgatlas'
      i.source_id = i.id
      return i
    }
  }
}

export default {
  name: 'ListwiseSelect',

  props: ['type'],

  data () {
    return {
      selectOptions: [],
      selection: null,
    }
  },

  methods: {
    focus () {
      this.$refs.select.$refs.search.focus()
    },
    change (item) {
      if (item) {
        this.$emit('add-selected', this.formatSelection(item))
        this.selectOptions = []
        this.selection = null
        this.focus()
      }
    },
    onSearch (search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, $vm) => {
      let {getUrl, getResults, formatResult} = content_types[$vm.type]
      fetch(getUrl(search)).then(res => {
        res.json().then(getResults).then(results => {
          $vm.selectOptions = results.map(formatResult).map(r => {r.origin = 'search'; return r})
        });
        loading(false);
      });
    }, 350),
    formatSelection (option) {
      return {
        content: option.name,
        link: '',
        thumbnail: option.thumbnail,
        details: option.overview,
        year: option.year,
        source_id: option.source_id,
        source: option.source,
        metadata: option
      }
    },
    createOption (newOption) {
      return {name: newOption, origin: 'custom'}
    }

  }
}
</script>

<style lang="scss">
.item-select-search.dropdown {
  &.open {
    .dropdown-toggle {
      border-bottom-right-radius: 0px;
      border-bottom-left-radius: 0px;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }
  }
  .dropdown-toggle {
    &:after {
        margin-top: 8px;
        opacity: 0;
    }
    .vs__actions {
      button.clear {
        span {
          vertical-align: text-bottom;
        }
      }
    }
  }
  &.v-select, &.v-select * {
    box-sizing: border-box;
    color: rgba(255, 255, 255, 0.8);
    &.single.open .selected-tag {
      position: relative;
      opacity: .4;
    }
    .open-indicator:before {
      border-color: rgba(230,230,230,1);
    }
  }
  color: white;
  .dropdown-menu {
    transform: none;
    visibility: initial;
    display: block;
    opacity: 1;
    transform: scale(1, 1) !important;
    background-color: #222225;
    border: 1px solid rgba(60,60,60,.26);
    border-top: none;
    li {
      display: block;
      overflow: hidden;
    }
  }
  img {
    width: 35px;
    object-fit: contain;
  }
  .option-content {
    display: inline-block;
    margin-left: 20px;
    vertical-align: middle;
    .overview {
      opacity: 0.8;
      font-size: 85%;
    }
    .year {
      opacity: 0.5;
      padding-left: 14px;
      font-size: 85%;
    }
  }
  .selected-option {
    max-height: 65px;
    text-overflow: ellipsis;
    overflow: hidden;
    display: flex;
    flex-direction: row;
  }
}
</style>